const envSettings = window as any;
const user = JSON.parse(localStorage.getItem("user")!);

export class Config {
  static platformwebapi_url = envSettings.API_URL;
  static token = user ? user.bearerToken : null;
  static accountfilterwebapi_url = envSettings.ACCOUNT_FILTER_API_URL;
}
